import { A, Background, Center, Div, DivSenha, H1, H2, Layout, Logo, P } from "./LoginStyled";
import React, { useState } from "react";
import {
  TextField,
  FormControl,
  InputLabel,
  OutlinedInput,
  InputAdornment,
  IconButton,
  Button,
  Box
} from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import useForm from "../../hooks/useForm";
import logo2 from "../../assets/images/logo2.jpg";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { goToHome } from "../../routes/Coordinator";
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import * as AiIcons from 'react-icons/ai';

const LoginPage = () => {
  const { form, onChangeForm, clear } = useForm({ email: "", password: "" });
  const [email, SetEmail] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [open, setOpen] = React.useState(false);

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '1px solid #000',
    boxShadow: 24,
    p: 4,
  };
  const handleSubmit = event => {
    event.preventDefault();
    login(event)
  };
  const login = (event) => {
    event.preventDefault()
    axios
      .post(`${process.env.REACT_APP_BASE_URL}/auth/sign_in`, form)
      .then((response) => {
        localStorage.setItem("access-token", response.headers['access-token'])
        localStorage.setItem("client", response.headers['client'])
        localStorage.setItem("expiry", response.headers['expiry'])
        localStorage.setItem("token-type", response.headers['token-type'])
        localStorage.setItem("uid", response.headers['uid'])
        localStorage.setItem("group_id", response.data.data['group_id'])
        localStorage.setItem("name", response.data.data['name'])
        goToHome(navigate)
      })
      .catch((erro) => {
        Object.keys(erro.response.data.errors).forEach((item) => {
          alert(erro.response.data.errors[item]);
        });
      }
      )
  }
  const newPassword = (event) => {
    event.preventDefault()
    axios
      .post(`${process.env.REACT_APP_BASE_URL}/auth/password`, { email, redirect_url: `${window.location.origin}/newpassword`})
      .then((response) => {
        alert("Email enviado")
      })
      .catch((erro) => {
        Object.keys(erro.response.data.errors).forEach((item) => {
          alert(erro.response.data[item]);
        });
      })

}

return (
  <div>
    <Background>
      <Layout>
        <Center>

          <Logo src={logo2}></Logo>
          <H1>INTELIGÊNCIA FINANCEIRA</H1>
          <form onSubmit={handleSubmit}>
            <TextField
              name={"email"}
              value={form.email}
              onChange={onChangeForm}
              label={"Email"}
              variant={"outlined"}
              sx={{ width: 350, marginBottom: 3, marginTop: 3 }}
              margin="dense"
              required
              type={"email"}
            />
            <FormControl>
              <InputLabel htmlFor="inputPassword">Senha</InputLabel>
              <OutlinedInput
                id="inputPassword"
                name={"password"}
                type={showPassword ? "text" : "password"}
                value={form.password}
                onChange={onChangeForm}
                variant={"outlined"}
                label="Senha"
                required
                sx={{ width: 350, marginBottom: 3 }}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={(e) => setShowPassword(!showPassword)}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>
            <Div>
              <Button
                fullWidth
                color="primary"
                variant="contained"
                type="submit"
              >
                Login
              </Button>
            </Div>
          </form>
          <DivSenha>
            <Button onClick={handleOpen}>
              <A href="#" className="recuperar_senha">
                Esqueceu a senha?
              </A>
            </Button>
            <Modal
              open={open}
              onClose={handleClose}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style}>
                <Typography id="modal-modal-title" variant="h6" component="h2">
                  Recuperar Senha
                </Typography>
                <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                  <FormControl sx={{ height: 40, width: "100%", marginLeft: 1, marginTop: 1, marginBottom: 2 }}>
                    <TextField
                      type="email"
                      label="Digite o email cadastrado"
                    onChange={(e) => SetEmail(e.target.value)}
                    />
                  </FormControl>
                  <Button sx={{ marginLeft: 20, marginTop: 1 }} onClick={(e) => newPassword(e)} variant="contained" color="success" >
                    Enviar
                  </Button>
                  <Button sx={{ marginTop: 1 }} onClick={handleClose} variant="outlined" startIcon={<AiIcons.AiFillCaretLeft />}>
                    Fechar
                  </Button>
                </Typography>
              </Box>
            </Modal>
          </DivSenha>
        </Center>
      </Layout>
    </Background>
  </div>
);
};

export default LoginPage;
